export default "<spec-app-type6-date-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type6-date-table>\n";